export interface FieldSpec {
  key: string;
  from?: string;
  defaultVal?: unknown;
  transform?: (val: unknown, obj: Record<string, unknown>) => unknown;
  reverseTransform?: (val: unknown, obj: Record<string, unknown>) => unknown;
}

export enum TransmuteDirection {
  FORWARD = 'forward',
  REVERSE = 'reverse',
}

export function transmute<T = unknown>(
  obj: object,
  fields: FieldSpec[],
  direction: TransmuteDirection = TransmuteDirection.FORWARD,
): T {
  if (!obj || typeof obj !== 'object') {
    throw new Error(`[transmute] input must be an object, got ${typeof obj}`);
  }

  const source = obj as Record<string, unknown>;
  const result: Record<string, unknown> = {};
  const isForward = direction === 'forward';

  for (const { key, from, defaultVal = '', transform, reverseTransform } of fields) {
    const sourceKey = isForward ? (from ?? key) : key;
    const targetKey = isForward ? key : (from ?? key);
    const t = isForward ? transform : (reverseTransform ?? transform);
    let val = source[sourceKey];

    if (val === undefined || val === null) {
      val = defaultVal;
    }

    if (t) {
      val = t(val, source);
    }

    result[targetKey] = val;
  }

  return result as T;
}
